import { Injectable } from "@angular/core";
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class EbetService {
    constructor(
        private httpService: HttpService
    ) { }

    //登录ebet
    loginEbet() {
        let url = AppConfig.GetProdUrl() + "/Ebet/LoginEbet";
        let par = {};
        return this.httpService.post(url, par);
    }


    /**
     * ebet转账
     * 0：向ebet转入，1：从ebet转出
     * @param {*} amount
     * @param {*} flag
     * @returns
     * @memberof EbetService
     */
    transfer(amount, flag) {
        let url = flag == '0' ? AppConfig.GetProdUrl() + "/Ebet/TransferToEbet" : AppConfig.GetProdUrl() + "/Ebet/TransferFromEbet";
        let par = flag == '0' ? { Money: amount, Type: 0 } : { Money: amount, Type: 1 };
        return this.httpService.post(url, par);
    }

    //判断开启关闭
    ebetStatus() {
        let url = AppConfig.GetProdUrl() + "/Ebet/EbetisOpen";
        return this.httpService.post(url, {});
    }

    getTransferStatus() {
        let url = AppConfig.GetProdUrl() + "/Report/GetDictions?CodeType=EbetTran";
        return this.httpService.get(url);
    }

    //获取转账记录
    getTransferList(params) {
        let url = AppConfig.GetProdUrl() + "/Ebet/GetTransferList";
        let par = { RecordCode: params.RecordCode, StartDate: params.StartDate, EndDate: params.EndDate, PageIndex: params.PageIndex, PageSize: params.PageSize, Status: params.Status, Type: params.Type };
        return this.httpService.post(url, par);
    }

    //获取游戏记录
    getEbetBetList(params) {
        let url = AppConfig.GetProdUrl() + "/Ebet/GetBettingList";
        let par = { StartDate: params.StartDate, EndDate: params.EndDate, PageIndex: params.PageIndex, PageSize: params.PageSize, BetHistoryId: params.GameId };
        return this.httpService.post(url, par);
    }

    //获取ebet余额
    getEbetBalance() {
        let url = AppConfig.GetProdUrl() + "/Ebet/GetBalance";
        return this.httpService.post(url, {});
    }

    /**
     * ebet获取个人盈亏报表
     */
    getUserReportList(params) {
        let url = AppConfig.GetProdUrl() + '/Ebet/GetUserReportList';
        return this.httpService.post(url, params);

    }
    /**
     *
     * EBET团队盈亏报表
     */
    getTeamReportList(params) {
        let url = AppConfig.GetProdUrl() + '/Ebet/GetTeamReportList';
        return this.httpService.post(url, params);
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/services/ebet.service.ts